export default [
  {
    name: 'custom_header_heks',
    path: 'modules/pages/heks/HeaderHeks'
  },
  {
    name: 'custom_footer_heks',
    path: 'modules/pages/heks/FooterHeks'
  },
]
